import { useState, useEffect, useCallback } from 'react';
import { query, mutate } from '../../defaults/fetch';

export const useGetAllTransactions = (refreshFlag) => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getAllTransactions = async () => {
      setLoading(true);
      const url = `inventory/transactions`;
      const { data } = await query(url, {});
      setLoading(false);
      setTransactions(data || []);
    }
    getAllTransactions();
  }, [refreshFlag]);

  return { loading, transactions };
};

export const useGetTransactionById = (id) => {
  const [transaction, setTransaction] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getTransaction = async () => {
      if (!id) return;
      setLoading(true);
      const url = `inventory/transactions/${id}`;
      const { data } = await query(url, {});
      setLoading(false);
      setTransaction(data || null);
    }
    getTransaction();
  }, [id]);

  return { loading, transaction };
};

export const useGetTransactionsByItem = (itemId) => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getTransactions = async () => {
      if (!itemId) return;
      setLoading(true);
      const url = `inventory/transactions/item/${itemId}`;
      const { data } = await query(url, {});
      setLoading(false);
      setTransactions(data || []);
    }
    getTransactions();
  }, [itemId]);

  return { loading, transactions };
};

export const useGetTransactionsByStore = (storeId) => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getTransactions = async () => {
      if (!storeId) return;
      setLoading(true);
      const url = `inventory/transactions/store/${storeId}`;
      const { data } = await query(url, {});
      setLoading(false);
      setTransactions(data || []);
    }
    getTransactions();
  }, [storeId]);

  return { loading, transactions };
};

export const useGetTransactionsByDepartment = (departmentId) => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getTransactions = async () => {
      if (!departmentId) return;
      setLoading(true);
      const url = `inventory/transactions/store-department/${departmentId}`;
      const { data } = await query(url, {});
      setLoading(false);
      setTransactions(data || []);
    }
    getTransactions();
  }, [departmentId]);

  return { loading, transactions };
};

export const useCreateTransaction = () => {
  return useCallback(async (transactionData) => {
    const url = `inventory/transactions`;
    const { message } = await mutate(url, true, transactionData);
    return message;
  }, []);
};